/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SlackChannelLink
 */
export interface SlackChannelLink {
    /**
     * 
     * @type {string}
     * @memberof SlackChannelLink
     */
    channelId: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannelLink
     */
    channelName?: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannelLink
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannelLink
     */
    initialStatusId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SlackChannelLink
     */
    createWithTags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncPostsToSlack?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncSlackToPosts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncCommentsToReplies?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncRepliesToComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncStatusUpdates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannelLink
     */
    syncResponseUpdates?: boolean;
}

export function SlackChannelLinkFromJSON(json: any): SlackChannelLink {
    return {
        'channelId': json['channelId'],
        'channelName': !exists(json, 'channelName') ? undefined : json['channelName'],
        'categoryId': json['categoryId'],
        'initialStatusId': !exists(json, 'initialStatusId') ? undefined : json['initialStatusId'],
        'createWithTags': !exists(json, 'createWithTags') ? undefined : json['createWithTags'],
        'syncPostsToSlack': !exists(json, 'syncPostsToSlack') ? undefined : json['syncPostsToSlack'],
        'syncSlackToPosts': !exists(json, 'syncSlackToPosts') ? undefined : json['syncSlackToPosts'],
        'syncCommentsToReplies': !exists(json, 'syncCommentsToReplies') ? undefined : json['syncCommentsToReplies'],
        'syncRepliesToComments': !exists(json, 'syncRepliesToComments') ? undefined : json['syncRepliesToComments'],
        'syncStatusUpdates': !exists(json, 'syncStatusUpdates') ? undefined : json['syncStatusUpdates'],
        'syncResponseUpdates': !exists(json, 'syncResponseUpdates') ? undefined : json['syncResponseUpdates'],
    };
}

export function SlackChannelLinkToJSON(value?: SlackChannelLink): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'channelId': value.channelId,
        'channelName': value.channelName,
        'categoryId': value.categoryId,
        'initialStatusId': value.initialStatusId,
        'createWithTags': value.createWithTags,
        'syncPostsToSlack': value.syncPostsToSlack,
        'syncSlackToPosts': value.syncSlackToPosts,
        'syncCommentsToReplies': value.syncCommentsToReplies,
        'syncRepliesToComments': value.syncRepliesToComments,
        'syncStatusUpdates': value.syncStatusUpdates,
        'syncResponseUpdates': value.syncResponseUpdates,
    };
}


